/**
 * Sorts an array of search results by the attribute body position.
 * @function sortByAttributeBodyPosition
 * @param {Record<string, unknown>[]} searchResults - The array of search results to sort.
 * @returns {Record<string, unknown>[]} The sorted array of search results.
 */
export const sortByAttributeBodyPosition = (
  searchResults: Record<string, unknown>[],
) => {
  const bodyPositionOrder = {
    head: 1,
    tops: 2,
    multi: 3,
    legs: 4,
    feet: 5,
    ears: 6,
    chest: 7,
    back: 8,
    arm: 9,
    hand: 10,
    hands: 11,
    finger: 12,
    fingers: 13,
    scene: 14,
  };

  const defaultSortPosition = 15; // Default sort position for items without a body position
  return searchResults.sort((a, b) => {
    const indexA =
      bodyPositionOrder[
        a.attribute_body_position as keyof typeof bodyPositionOrder
      ] ?? defaultSortPosition;
    const indexB =
      bodyPositionOrder[
        b.attribute_body_position as keyof typeof bodyPositionOrder
      ] ?? defaultSortPosition;
    return indexA - indexB;
  });
};
